import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '../../../../../../infra/i18n';
import { CampaignNameAndDescription } from './campaign-name-description';
import { AudienceColumn } from './audience-column';
import { OpenRateColumn } from './open-rate-column';
import { FrequencyColumn } from './frequency-column';
import { ToggleColumn } from './toggle-column';
import { ActionsColumn } from './actions-column';
import { Expander } from './expander';
import { CAMPAIGN_COLUMN_ID, AUDIENCE_COLUMN_ID, OPEN_RATE_COLUMN_ID, FREQUENCY_COLUMN_ID, TOGGLE_COLUMN_ID, ACTIONS_COLUMN_ID, EXPANDER_COLUMN_ID, } from './constants';
export var getAutomatedCampaignColumns = function () { return [
    {
        id: CAMPAIGN_COLUMN_ID,
        header: t('engage:table.headers.campaign'),
        accessorKey: 'name',
        cell: function (cellContext) {
            var campaign = cellContext.row.original;
            return _jsx(CampaignNameAndDescription, { name: campaign.name, description: campaign.description });
        },
        size: 1,
        minSize: 180,
        meta: {
            isFlex: true,
        },
        sortingFn: 'text',
    },
    {
        id: AUDIENCE_COLUMN_ID,
        header: t('engage:table.headers.audience'),
        accessorKey: 'audience',
        cell: function (cellContext) {
            var campaign = cellContext.row.original;
            return _jsx(AudienceColumn, { audienceNames: campaign.audience, totalCount: campaign.totalAudienceCount });
        },
        size: 200,
        minSize: 200,
    },
    {
        id: OPEN_RATE_COLUMN_ID,
        header: t('engage:table.headers.open_rate'),
        accessorKey: 'openRate',
        cell: function (cellContext) {
            var campaign = cellContext.row.original;
            return _jsx(OpenRateColumn, { campaign: campaign });
        },
        size: 115,
        minSize: 85,
    },
    {
        id: FREQUENCY_COLUMN_ID,
        header: t('engage:table.headers.frequency'),
        accessorKey: 'frequency',
        cell: function (cellContext) {
            var campaign = cellContext.row.original;
            return _jsx(FrequencyColumn, { frequency: campaign.frequency, isRecurring: campaign.isRecurring });
        },
        size: 200,
        minSize: 200,
    },
    {
        id: TOGGLE_COLUMN_ID,
        header: '',
        accessorKey: 'isEnabled',
        cell: function (cellContext) {
            var campaign = cellContext.row.original;
            return (_jsx(ToggleColumn, { campaignName: campaign.definition.name, isEnabled: campaign.isEnabled, campaignId: campaign.id, subtype: campaign.definition.subtype }));
        },
        size: 80,
        minSize: 80,
        enableSorting: false,
    },
    {
        id: ACTIONS_COLUMN_ID,
        header: '',
        accessorKey: 'actions',
        cell: function () { return _jsx(ActionsColumn, {}); },
        size: 34,
        enableSorting: false,
    },
    {
        id: EXPANDER_COLUMN_ID,
        accessorKey: 'id',
        header: '',
        cell: function (cellContext) { return _jsx(Expander, { isExpanded: cellContext.row.getIsExpanded() }); },
        size: 15,
    },
]; };
